import Tippy from '@tippyjs/react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { toggleFilter } from '../../../../redux/actions';

const useStyles = createUseStyles({
  button: {
    '&.hidden': { opacity: 0.25 },
    '&:hover': { opacity: 0.65 },
    borderRadius: 14,
    composes: ['is-relative', 'mb6', 'mr6', 'no-overflow'],
    height: 28,
    opacity: 1,
    transition: 'opacity 0.3s',
    width: 28,
  },
  scores: {
    color: '#919191',
    composes: ['ml6'],
  },
  tooltip: {
    background: '#202124',
    color: '#FFFFFF',
    composes: ['fs11', 'is-bold'],
  },
  wrapper: {
    composes: ['is-absolute', 'is-top-left'],
  },
});

const CategoryButtonComponent = React.memo(({ data, score }) => {
  const { Icon, color: background, id, label } = data;
  const classes = useStyles();
  const dispatch = useDispatch();
  const filters = useSelector(_ => _.filters);

  const clickHandler = useCallback(
    (type, visible) => dispatch(toggleFilter([type], visible)),
    [dispatch]
  );

  const hidden = filters.includes(id);

  return (
    <Tippy
      arrow={false}
      className={classes.tooltip}
      content={
        <React.Fragment>
          <span>{label}</span>
          <span className={classes.scores}>
            ({score.count}/{score.total})
          </span>
        </React.Fragment>
      }
      offset={[0, 3]}
      placement="top">
      <button
        key={id}
        className={classnames(classes.button, { hidden })}
        style={{ background }}
        type="button"
        onClick={() => clickHandler(id, !hidden)}>
        <div className={classes.wrapper}>
          <Icon
            background="transparent"
            style={{ marginLeft: 0, marginTop: 0 }}
          />
        </div>
      </button>
    </Tippy>
  );
});

CategoryButtonComponent.propTypes = {
  data: PropTypes.shape().isRequired,
  score: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ count: PropTypes.number, total: PropTypes.number }),
  ]).isRequired,
};

CategoryButtonComponent.displayName = 'CategoryButtonComponent';

export default CategoryButtonComponent;
